import React, { Component } from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import drilldown from 'highcharts/modules/drilldown.js';

import 'react-datepicker/dist/react-datepicker.css';
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

// koneksi
import { GetMain } from '../../../function/Koneksi';
import { DataToken } from '../../../function/Format';
import { Col } from "reactstrap";
import { Link } from 'react-router-dom';

// Import custom components
import Breadcrumb from '../../common/breadcrumb.component';

drilldown(Highcharts);

class Default extends Component {
	constructor(props) {
		super(props);

		this.state = {
			akun: DataToken(localStorage.getItem('access_token')),
			tahun_desa: null,
			total_desa: [],
			drilldown_total_desa: [],

			total_yang_akan_berakhir: [],
			total_count: '',
		};
	}

	getTotalDesa = (tahun) => {

		let filter = tahun ? '?year=' + tahun.getFullYear() : '';

		GetMain('main/web/list-api/get-desa' + filter, null, (data) => {
			let total_desa = [];
			let drilldown_total_desa = [];

			if (data.results) {
				console.log("Processing data...");
				data.results.forEach((element, index) => {
					total_desa.push({
						name: element.nama,
						y: element.total,
						drilldown: element.nama + index,
					});
		
					let drilldown2 = [];
					if (element.detail) {
						element.detail.forEach((el) => {
							drilldown2.push({
								name: el.data_desa.nama,
								y: 1,
							});
						});
					}
		
					drilldown_total_desa.push({
						id: element.nama + index,
						name: 'Total data',
						data: drilldown2,
					});
					this.setState({ total_desa, drilldown_total_desa });
				});
			}
		})
	}

	highchartStatisticFunction = (data_chart, drilldown_chart, title_chart) => {
		const options = {
		  chart: {
			type: "column"
		  },
		  credits: {
			enabled: false
		  },
		  title: {
			text: title_chart
		  },
		  xAxis: {
			type: "category",
			min: 0,
			max: 4,
		  },
		  legend: {
			enabled: false
		  },
		  series: [
			{
			  name: "Jumlah Desa",
			  colorByPoint: true,
			  data: data_chart
			}
		  ],
		  drilldown: {
			series: drilldown_chart
		  },
		  scrollbar: {
			enabled: true
		  }
		};
		return options;
	};

	componentDidMount() {

		this.getTotalDesa();

		GetMain('main/web/list-api/expired-terdekat', null, (data) => {
			let total_yang_akan_berakhir = []; 
			let total_count = 0;

			if (data.results) {
				for (var [ index, data_exp ] of data.results.entries()) {
					total_yang_akan_berakhir.push({
						name: data_exp.nama,
						y: data_exp.total,
						drilldown: data_exp.nama + index
					});

					total_count += data_exp.total; 
				}
			}
			this.setState({ total_yang_akan_berakhir, total_count });
		});

	}

	render() {

		// =====================================================================
		// console.log(this.state.produk_tahun);
		// console.log(this.state.detail_produk_desa);
		const Highcharts = require('highcharts/highstock');
		drilldown(Highcharts);
		return (
			<div>
				{/*Container-fluid starts*/}
				<Breadcrumb title="Dashboard" parent="Admin" />
				{/*Container-fluid Ends*/}

				{/*Container-fluid starts*/}
				<div className="container-fluid">
					{this.state.akun.sub.data_role.nama !== "Admin Tim Bisnis" ? (
							''
						) : (
							<div className="row">
								<div className="col-xl-12 col-lg-12">
								<Link to="/main/list-desa" style={{ textDecoration: 'none', color: 'inherit' }}>
									<div className="card">
										<div className="card-content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
											<div className="card-body">
												<div className="media d-flex align-items-center">
												<div className="align-self-center" style={{ marginRight: '10px' }}>
													<i className="icon-user" style={{ fontSize: '48px' }}></i>
												</div>
												<div className="media-body text-center">
													<h3 style={{ margin: 0 }}>{this.state.total_count}</h3>
													<span>Total Layanan yang Akan Berakhir <br /> 
														<small style={{color:"red"}}>* Dalam 1 Bulan Terakhir</small>
													</span>
												</div>
												</div>
											</div>
										</div>
									</div>
									</Link>
								</div>
								<div className="col-xl-12 col-lg-12">
									<div className="card">
										<div className="card-header">
										<h5>Chart Total Desa</h5>
										</div>
										<div className="card-header">
											<Col sm="12">
											<Datetime
												inputProps={{
													"data-testid": "tahun_desa",
													placeholder: "Semua Tahun",
												}}
												inputId="tahun_desa"
												className="mb-3"
												name="tahun_desa"
												locale="id-ID"
												timeFormat={false}
												dateFormat="YYYY"
												input={true}
												closeOnTab={true}
												initialValue={this.state.tahun_desa}
												value={this.state.tahun_desa}
												onChange={(date) => {
													if (date && date._isValid !== undefined) {
														const formattedDate = date.format("YYYY-MM-DD");
														const tahun = new Date(formattedDate);
														this.setState({
															tahun_desa: tahun,
															total_desa: [],
															drilldown_total_desa: [],
														});
														this.getTotalDesa(tahun);
													} else {
														// Clear year filter and fetch all data
														this.setState({
															tahun_desa: null,
															total_desa: [],
															drilldown_total_desa: [],
														});
														this.getTotalDesa();
													}
												}}
											/>
											</Col>
										</div>
										<div className="card-body">
											<div className="dashboard-chart-container sales-overview-chart">
												{this.state.total_desa.length === 0 ? (
													<div className="text-center">Tidak Ada Data</div>
												) : (
													<HighchartsReact
													highcharts={Highcharts}
													options={this.highchartStatisticFunction(
														this.state.total_desa,
														this.state.drilldown_total_desa,
														'Data Total Digidesa'
													)}
													/>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						)}
				</div>
				{/*Container-fluid Ends*/}
			</div>
		);
	}
}

export default Default;
